import type { ReactElement } from 'react';
import { useServices, useT } from '../../../app/di';
import { Card } from '../../../ui-kit/Card/Card';
import { ApiKeysConnected } from './ApiKeysConnected';
import { toIssueRequest } from './model/api-keys';

// IAM-UC-9, IAM-UC-10: свои ключи автора — секция профиля.
export function ApiKeysSection(): ReactElement {
  const { api } = useServices();
  const { t } = useT();
  return (
    <Card title={t('identity.apiKeys.title')}>
      <div className="u-stack">
        <p className="u-muted">{t('identity.apiKeys.subtitle')}</p>
        <ApiKeysConnected
          list={() => api.identity.myApiKeys()}
          issue={(values) => api.identity.issueMyApiKey(toIssueRequest(values))}
          revoke={(keyId) => api.identity.revokeMyApiKey(keyId)}
          remove={(keyId) => api.identity.deleteMyApiKey(keyId)}
        />
      </div>
    </Card>
  );
}
